import { DASHBOARD_URL } from 'src/dataLayer/env'

// eslint-disable-next-line regexp/no-unused-capturing-group -- Legacy
const BABBEL_URL_REGEX = /([a-z0-9]+\.)?(babbel)\.(com|cn|io)$/
const ENCODED_RETURN_TO_REGEX = /return_to=https?%3A%2F%2F/

const ENV_DOMAINS = ['com', 'cn', 'test']
const ENV_DOMAINS_REGEX = new RegExp(
  `(${ENV_DOMAINS.map((environment) => `.${environment}`).join('|')})`,
)

// eslint-disable-next-line no-restricted-globals -- Legacy
const getRawQueryString = () => `?${new URLSearchParams(location.search).toString()}`

const isValidBabbelReturnUrl = (returnToFromQuery) => {
  try {
    const decodedReturnToURLObject = new URL(decodeURIComponent(returnToFromQuery))
    return BABBEL_URL_REGEX.test(decodedReturnToURLObject.hostname)
  } catch {
    return false
  }
}

const getEnvironmentDomainToUpdateReturnTo = (returnToURL) => {
  const currentURL = globalThis.location.href

  // eslint-disable-next-line unicorn/no-array-reduce -- Legacy
  return ENV_DOMAINS.reduce((domainToReplace, domain) => {
    const regexEnvironmentDomain = new RegExp(
      `(http|https)\:\/\/[a-zA-Z0-9\-\.]+\.(${domain})+(\/\S*)?`,
    )
    const isDomainEnvironmentInCurrentURL = regexEnvironmentDomain.test(currentURL)
    const isDomainEnvironmentInReturnToURL = regexEnvironmentDomain.test(returnToURL)
    return isDomainEnvironmentInCurrentURL && !isDomainEnvironmentInReturnToURL
      ? domain
      : domainToReplace
  }, null)
}

const getReturnUrlWithValidEnvironment = (returnToURL) => {
  const environmentToReplace = getEnvironmentDomainToUpdateReturnTo(returnToURL)

  if (!environmentToReplace) {
    return returnToURL
  }

  const updatedReturnToURL = returnToURL.replace(ENV_DOMAINS_REGEX, `.${environmentToReplace}`)
  return updatedReturnToURL
}

// getValidQueryParams is used to get valid query params when changing the route.
// Invalid return_to params will be removed on route change.
const getValidQueryParams = (queryParametersString) => {
  const queryParameters = new URLSearchParams(queryParametersString)
  const returnToURL = queryParameters.get('return_to')

  if (!isValidBabbelReturnUrl(returnToURL)) {
    queryParameters.delete('return_to')
  }

  return queryParameters
}

// Return a string of the validated query params
const getQueryParamsString = (queryParameters) =>
  queryParameters.toString() === '' ? '' : `?${queryParameters.toString()}`

/*
 * Returns the `return_to` query param of a URL if the value is a valid Babbel url.
 * If the return_to param is missing or is not a Babbel url, it returns the dashboard url.
 */
const getReturnToUrl = (queryParameters, encoded = true) => {
  // return the dashboard URL if the url is not encoded, since its query params will be trimmed otherwise
  if (!ENCODED_RETURN_TO_REGEX.test(globalThis.location.href)) {
    return encoded ? encodeURIComponent(DASHBOARD_URL) : DASHBOARD_URL
  }

  const queryParametersObject =
    typeof queryParameters === 'string' ? new URLSearchParams(queryParameters) : queryParameters

  const { return_to: returnToURL } = Object.fromEntries(queryParametersObject)

  const decodedURL = isValidBabbelReturnUrl(returnToURL)
    ? getReturnUrlWithValidEnvironment(returnToURL)
    : DASHBOARD_URL

  return encoded ? encodeURIComponent(decodedURL) : decodedURL
}

export {
  getQueryParamsString,
  getRawQueryString,
  getReturnToUrl,
  getValidQueryParams,
  isValidBabbelReturnUrl,
}
